import React from "react";
import { MapPin } from "lucide-react";

export default function Locations() {
  return (
    <section id="sedi" data-testid="locations-section" className="relative py-24 md:py-32 bg-[#FDFBF7] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "url(https://static.prod-images.emergentagent.com/jobs/d9f66b95-beed-4fd5-86c5-228cbccaea7e/images/d6a194146fcd11ce8467b74eb378b5522a956b84cc5211c7d035783acc35bef0.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="container-ed relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="overline mb-6">Le sedi dello Studio</div>
            <h2 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0F172A]">
              Abruzzo e Piemonte, <span className="italic text-[#A38A5A]">una sola squadra</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-[#57534E]">
              Lo Studio riceve su appuntamento. È possibile concordare un incontro in
              presenza o una consulenza da remoto in videoconferenza.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            {
              city: "Chieti",
              province: "(CH) — Abruzzo",
              address: "Via Spaventa, 29",
              map: "https://www.google.com/maps?q=Via+Spaventa+29,+Chieti+CH&output=embed",
              owner: "Avv. Giovanna Scotti",
            },
            {
              city: "Bra",
              province: "(CN) — Cuneo",
              address: "Via Provvidenza, 31",
              map: "https://www.google.com/maps?q=Via+Provvidenza+31,+Bra+CN&output=embed",
              owner: "Avv. Salvatore F. A. Bava",
            },
          ].map((loc) => (
            <div
              key={loc.city}
              data-testid={`location-${loc.city.toLowerCase()}`}
              className="bg-white border border-black/10"
            >
              <div className="aspect-[16/10] w-full bg-[#0B101A] relative">
                <iframe
                  title={`Mappa ${loc.city}`}
                  src={loc.map}
                  loading="lazy"
                  className="w-full h-full border-0"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="p-8">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 mt-1 text-[#A38A5A]" strokeWidth={1.5} />
                  <div>
                    <div className="overline text-[10px]">{loc.province}</div>
                    <h3 className="serif text-3xl md:text-4xl text-[#0F172A] mt-1">{loc.city}</h3>
                    <p className="mt-2 text-sm text-[#57534E]">{loc.address}</p>
                    <p className="mt-4 text-sm text-[#1C1917]">{loc.owner}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
